module.exports = __webpack_public_path__ + "img/1-2.4c38c27a.svg";